import { render, staticRenderFns } from "./MobilePlatformsLayer.vue?vue&type=template&id=6aa76fd2&"
import script from "./MobilePlatformsLayer.vue?vue&type=script&lang=ts&"
export * from "./MobilePlatformsLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports